import React from "react";
import MapDataHelper from "../data/MapDataHelper.js";
import "./styles/MapWinRate.css";

export default function MapWinRate(map) {
  return (
    <article className="map-win-rate">
      <div className="map-win-rate-image">
        <img
          src={MapDataHelper.getMapImage(map.map)}
          alt={map.map}
          title={map.map}
        />
        <div className="centered-map-name">{map.map}</div>
      </div>
      <div className="map-win-rate-stats">
        <p>⚔️ {map.wins}</p>
        <p>💀 {map.looses}</p>
      </div>
    </article>
  );
}
